import styled from 'styled-components';
import {
  BackgroundContainer,
} from '../../../utils/atoms';
import {
  mobile,
} from '../../../utils/breakpoints';

export const FaqContainer = styled(BackgroundContainer)`
  padding: 60px;
  text-align: left;
  max-width: 1200px;
  margin: 0 auto;

  @media(max-width: ${mobile.max}px) {
    padding: 30px;
  }
`;


export const FaqList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
`;

export const FaqCol = styled.div`
  width: calc(50% - 15px);
  flex-basis: calc(50% - 15px);
  &:first-of-type{
    margin-right: 15px;
  }

  > p, div {
    width: 100%;
  }

  @media(max-width: ${mobile.max}px) {
    width: 100%;
    flex-basis: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/components/faq/styles/faqs-block.style.js